import React from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
// Import Utils
import auth from 'shared-components/src/utils/auth';

const RouteWrapper = ({ priv = false, children }) => {
  const isAuthenticated = !!auth.isAuthenticated();
  const { pathname } = window.location;
  const isDisbursementsPath = pathname.startsWith('/disbursements');
  const isMFAPath = pathname === '/mfa-setup' || pathname === '/mfa-verify';
  // Checks for Authentication
  if (priv && !isAuthenticated) return <Navigate to="/login" />;
  if (!priv && isAuthenticated && !isDisbursementsPath && !isMFAPath)
    return <Navigate to="/" />;
  return children;
};

RouteWrapper.propTypes = {
  priv: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default RouteWrapper;
